import axios from "axios";
import EventBus from "@/libs/eventBus";
import nprogress from "nprogress";
import '@/assets/nprogress.css';

// Lấy URL API từ biến môi trường
export const baseURL = process.env.VUE_APP_API_BASE_URL || "http://localhost:8000";

// Tạo instance Axios
const api = axios.create({
  baseURL: baseURL + "/api/v1/",
  timeout: 10000,
  headers: { "Content-Type": "application/json" },
});

// Hàm phát thông báo
const emitNotification = (title, message, type = "danger", showtime = 2000) => {
  EventBus.emit("show-notification", JSON.stringify({ title, message, type, showtime }));
};

// Interceptor cho request
api.interceptors.request.use(
  (config) => {
    nprogress.start();
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor cho response
api.interceptors.response.use(
  (response) => {
    nprogress.done();
    if (response.status === 201 || response?.data?.success === true) {
      emitNotification("Thông báo", response.data.message || "Thành công", "success");
    }
    return response;
  },
  (error) => {
    nprogress.done();
    const status = error?.response?.status;
    const message = error?.response?.data?.message || "Có lỗi xảy ra";

    if(error?.code === "ECONNABORTED") {
      emitNotification("Thông báo", "Đã xảy ra lỗi server, vui lòng thử lại sau.", "danger");
    }
    // Xử lý lỗi theo mã
    if ([400, 422, 500].includes(status)) {
      emitNotification("Thông báo", message, "danger");
    }
    if (status === 403) {
      localStorage.removeItem('token')
      emitNotification("Thông báo", message, "danger");
    }
    if (status === 401) {
      localStorage.removeItem('token')
      EventBus.emit("login", JSON.stringify({ message: "Vui lòng đăng nhập để thực hiện các chức năng." }), "danger", 2000);
    }
    return Promise.reject(error);
  }
);

// Hàm tùy chỉnh để gọi API
export const customApi = async ({ method = "GET", url, data = null, headers = {} }) => {
  try {
    const response = await api({
      method,
      url,
      data,
      headers: {
        ...api.defaults.headers,
        ...headers,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in customApi:", error);
    throw error;
  }
};

export default api;
